import { render, staticRenderFns } from "./Auditoria.vue?vue&type=template&id=513ece62"
import script from "./Auditoria.vue?vue&type=script&lang=js"
export * from "./Auditoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports